import { colors } from "~/styleguide";

export const fancyList = {
    backgroundColor: colors.white,
    boxShadow: "0px 2px 9px rgba(0, 0, 0, 0.03)",
    borderRadius: 6,
    overflow: "hidden",
    padding: "30px 25px",
    marginBottom: 12,
    position: "relative",
    ":last-of-type": {
        marginBottom: 0
    }
};
